export default "__VITE_ASSET__DxGswXVn__"